import React, { useEffect, useState } from 'react';
import ArrowUp from 'assets/icons/common/arrow-up.svg';
import ArrowDown from 'assets/icons/common/arrow-down.svg';
import useAnimation from '_helpers/hooks/useAnimation';
import PUBLIC_ROUTES from '_helpers/constants/ConstPublicRoutes';
import Paragraph from 'components/atoms/text/paragraph';
import CapitalizeFirstLetter from '_helpers/generic/CapitalizeFirstLetter';
import { Link } from 'react-router-dom';
import determineAnimation from '_helpers/generic/Animations';

export default function NavigationArrows() {
  const { currentPageIndex, setAnimation, setCurrentPageIndex, nextPage, setNextPage, previousPage, setPreviousPage } =
    useAnimation();

  useEffect(() => {
    setNextPage(PUBLIC_ROUTES[currentPageIndex + 1]);
    setPreviousPage(PUBLIC_ROUTES[currentPageIndex - 1]);
  }, [currentPageIndex]);

  return (
    <>
      {currentPageIndex !== 0 && (
        <Link
          className="z-50 rocket absolute transform -translate-x-1/2 left-1/2 top-3"
          to={previousPage?.path}
          onClick={() => {
            setAnimation(determineAnimation(previousPage?.path));
            setCurrentPageIndex(currentPageIndex - 1);
          }}>
          <img src={ArrowUp} className="mx-auto" alt="Navigation Arrow Up" />
          <Paragraph
            styles="!font-semibold"
            text={previousPage?.path === '/' ? 'Home' : CapitalizeFirstLetter(previousPage?.path?.slice(1) ?? '')}
          />
        </Link>
      )}
      {currentPageIndex !== PUBLIC_ROUTES.length - 1 && (
        <Link
          to={nextPage?.path}
          className="z-50 rocket absolute transform -translate-x-1/2 left-1/2 bottom-3"
          onClick={() => {
            setAnimation(determineAnimation(nextPage?.path));
            setCurrentPageIndex(currentPageIndex + 1);
          }}>
          <Paragraph styles="!font-semibold" text={CapitalizeFirstLetter(nextPage?.path?.slice(1) ?? '')} />
          <img className="mx-auto" src={ArrowDown} alt="Navigation Arrow Down" />
        </Link>
      )}
    </>
  );
}
